module.exports = __webpack_public_path__ + "img/image_2-fe943685.png";